module.exports = __webpack_public_path__ + "img/mara_2kl.08e37b9f.jpg";